export const ONE_SECOND = 1000

export const FIFTY_PERCENT_VIEWABLE = 0.5
